var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('promo.form.banner')))]),_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.initialValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }